import React from "react";
import moment from 'moment';
import {component_tool, utils_tool} from "@/tool";
import { WizTableForm,WizClassifySelect } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, isNotAuth: true } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, isNotAuth: true } })
let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'examRecord';

let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = (data) => {
  const {examId,personIds} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "任职",
      name: "userIdentityInfo",
      tableItem: {
        width: 350,
      },
    },
    {
      title: "答错次数",
      name: "count",
      tableItem: {
      },
    },
    
  ]
};

const templateConfig = (data) => {
  const {} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        btnAccessCheck:false,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['export'],
          buttons: [
            
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters, examId: data.examId ,personIds:data.personIds}
                }
              }
            },
          ]
        },
       
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: [],
        rowOperateView: [
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {examId,personIds} = data;
  return {
    list: {
      path: `${componentName}/getErrorQuestionPersonInfoPage`,
      payload: {
        key: `${componentName}@getErrorQuestionPersonInfoPage`,
        apiParams: {pageNum: 1, pageSize: 10,examId,personIds}
      }
    },
    export: {
      path: `${componentName}/getErrorQuestionPersonInfoExport`,
      payload: {
        key: `${componentName}@getErrorQuestionPersonInfoExport`,
        apiParams: {examId,personIds}
      }
    },
  }
};


let reduxTemplateConfig = (args) => {
  const {examId,personIds} = args;
  return {
    apis: apis({examId,personIds}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
